
export default {
  dialogClickModal:false,
        height: 'auto',
        calcHeight: 90,
        dialogHeight:530,
        dialogTop:35,
        tip: false,
        dialogWidth:'65%',
        // dialogHeight:432,
        border: true,
        index: true,
        indexLabel: "序号",
        viewBtn: true,
        selection: true,
        // delBtn: false,
        searchMenuSpan: 18,
        columnBtn: true,
        refreshBtn: true,
        column: [
          {
            label: "主键",
            prop: "id",
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            rules: [{
              required: true,
              message: "请输入主键",
              trigger: "blur"
            }]
          },
          {
            label: "项目编号",
            prop: "code",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [{
              required: true,
              message: "请输入项目编号",
              trigger: "blur"
            }]
          },
          {
            label: "项目名称",
            prop: "name",
            search: true,
            maxlength: 30,
            showWordLimit: true,
            overHidden: true,
            rules: [{
              required: true,
              message: "请输入项目名称",
              trigger: "blur"
            }]
          },
          {
            label: "项目业态",
            prop: "commercialType",
            search: true,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=project_commercial_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{
              required: true,
              message: "请输入项目业态",
              trigger: "blur"
            }]
          },
          {
            label: "承接方式",
            prop: "undertakeType",
            search: true,
            type: 'select',
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=project_undertake_type',
            props: { label: 'dictValue', value: 'dictKey' },
            rules: [{
              required: true,
              message: "项目承接方式",
              trigger: "blur"
            }],
            change(){}
          },
          {
            label: "所属机构",
            prop: "deptId",
            search: true,
            type: "tree",
            // viewDisplay: false,
            hide: true,
            dicUrl: 'api/v4ward/dept/treeByIds',
            props: { label: 'title', value: 'key' },
            rules: [{
              required: true,
              message: "请选择所属机构",
              trigger: "change"
            }],
            formslot:true
          },
          {
            label: "负责人",
            prop: "chargeManId",
            formslot:true,
            hide:true,
            
            // type: "tree",
            // hide: true,
            // // formslot: true,
            // // dicUrl: '/api/v4ward/user/userList',
            // props: { label: 'realNameAndPhone', value: 'id' },
            // rules: [{
            //   required: true,
            //   message: "请输入负责人",
            //   trigger: "change"
            // }]
          },
          
          {
            label: "负责人",
            prop: "realName",
            viewDisplay: false,
            editDisplay: false,
            addDisplay: false,
          },
          {
            label: "手机号",
            prop: "phone",
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
          },
          {
            label: "地址",
            prop: "addr",
            type: 'textarea',
            overHidden: true,
            span: 24,
            row: 1,
            maxlength: 200,
            showWordLimit: true,
            rules: [{
              required: true,
              message: "请输入地址",
              trigger: "blur"
            }]
          },
          {
            label: "经度",
            prop: "locationLongitude",
            maxlength: 20,
            showWordLimit: true,
            rules: [{
              required: true,
              message: "请输入经度",
              trigger: "blur"
            }]
          },
          {
            label: "纬度",
            prop: "locationLatitude",
            maxlength: 20,
            showWordLimit: true,
            rules: [
              {
              required: true,
              message: "请输入纬度",
              trigger: "blur"
            }]
          },
         
          {
            label: "建筑面积",
            prop: "structureArea",
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^\d+(\.\d{0,2})?$/, message: '请输入正确的数字，最多精确到小数点后2位' },
                    ]
          },
          {
            label: "管理面积",
            prop: "manageArea",
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^\d+(\.\d{0,2})?$/, message: '请输入正确的数字，最多精确到小数点后2位' },
            ]
          },
         
          {
            label: "签到半径",
            prop: "signInRadius",
            editDisplay: false,
            addDisplay: false,
            viewDisplay: false,
            hide: true,
            precision: 2,
            maxlength: 8,
            showWordLimit: true,
            rules: [
              { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入自然数' },
            ]
          },
          // {
          //   label: "所属机构a",
          //   prop: "deptId2",
          //   type: "tree",
          //   editDisplay: false,
          //   addDisplay: false,
          //   dicUrl: 'api/v4ward/dept/tree',
          //   props: { label: 'title', value: 'key' },
          //   rules: [{
          //     required: true,
          //     message: "请选择所属机构",
          //     trigger: "change"
          //   }]
          // },
          
          {
            label: "合同状态",
            prop: "status",
            type: "switch",
            slot: true,
            addDisplay: false,
            dataType: 'number',
            dicUrl: 'api/blade-system/dict/dictionary?code=project_status_type',
            props: { label: 'dictValue', value: 'dictKey' },
          },
          {
            label: '平面图',
            prop: 'attachIds',
            formslot: true,
            hide: true,
            span: 24,
          },
        ]
      
}
